// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_scss_components__calculator_scss":"7cb74d9b5a18b2cec7a4","src_js_swipers_js":"9a74a3b38b2ebd2dde85","node_modules_swiper_swiper_min_css":"67e8d198daf5db82b9ff","node_modules_swiper_modules_pagination_pagination_min_css":"eb5c4d2f87b2841995d2"}[chunkId] + ".css";
};